import Vue from 'vue'
import Swal from 'sweetalert2'

export function notificationConfirm(icon, title) {
  Vue.swal({
    icon: icon,
    title: title,
    showConfirmButton: true,
    confirmButtonText: 'Ok',
  })
}

export function notification(icon, title, timer) {
  Vue.swal({
    icon: icon,
    title: title,
    showConfirmButton: false,
    timer: timer,
  })
}

export function notificationAck(icon, title, msg) {
  Swal.fire({
    title: title,
    html: msg,
    icon: icon,
    showCancelButton: false,
    confirmButtonText: 'Ok',
  })
}

export async function confirmAlertDisplay(title, text) {
  let response = false
  await Swal.fire({
    title: title,
    text: text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#34c38f',
    cancelButtonColor: '#f46a6a',
    confirmButtonText: 'ใช่',
    cancelButtonText: 'ไม่ใช่',
  }).then(result => {
    if (result.isConfirmed) {
      response = true
    } else {
      response = false
    }
  })
  return response
}

export function isValid(value) {
  return value !== undefined && value !== null && value !== '' ? true : false
}
